import styled from "styled-components"

type Props = {
    onClick?: () => void
}

const Container = styled.button``

const NiceButton: React.FC<Props> = ({ children, onClick }) => {

    return <>
        {onClick && <Container className='button-nice' onClick={onClick}>
            {children}
        </Container>}
        {!onClick && <Container className='button-nice'>
            {children}
        </Container>}
    </>
}

export default NiceButton;
